<template>
  <div class="tw:flex tw:flex-wrap tw:sm:flex-nowrap tw:gap-4">
    <ProductReportDetailsImage :img="imageUrl" :is-loading="isLoading" />

    <div class="tw:flex tw:flex-col tw:w-full tw:divide-y tw:divide-default-200">
      <ProductReportDetailsRow label="ID" :value="appIdProductId?.split('_')[1]" :is-loading="!appIdProductId" />

      <ProductReportDetailsRow
        :label="trans._products.content.drawer.productName"
        :value="productName"
        :is-loading="isLoading"
      >
        <div class="tw:flex tw:flex-col tw:gap-2">
          <p class="tw:body-2 tw:text-black">{{ productName }}</p>
          <div class="tw:flex tw:flex-row tw:items-center tw:gap-2">
            <ProductAvailability :is-available="isAvailable" />

            <EdroneBadge
              v-if="isBestseller"
              type="info"
              :label="trans._products.content.bestseller"
              icon="fa-regular fa-star"
              size="small"
            ></EdroneBadge>
          </div>
        </div>
      </ProductReportDetailsRow>

      <ProductReportDetailsRow
        :label="trans._products.content.drawer.price"
        :value="price ? formatPrice(price) : null"
        :is-loading="isLoading"
      />

      <ProductReportDetailsRow :label="trans._products.content.drawer.url" :is-loading="isLoading">
        <a
          v-if="url"
          class="tw:body-2 tw:text-black tw:!underline tw:overflow-hidden tw:text-ellipsis tw:whitespace-nowrap tw:w-[15rem]"
          :href="url"
          target="_blank"
        >
          {{ url }}
        </a>
        <p v-else class="tw:body-2 tw:text-black">-</p>
      </ProductReportDetailsRow>

      <ProductReportDetailsRow
        :label="trans._products.content.drawer.status.title"
        :tooltip="trans._products.content.drawer.status.promoteTooltip"
        :is-loading="isLoading"
      >
        <ProductRecommendationStatusToggle
          :recommendation-status="recommendationStatus"
          :is-disabled="!isAvailable"
          @update-recommendation-status="(status) => $emit('updateRecommendationStatus', status)"
        />
      </ProductReportDetailsRow>
    </div>
  </div>
</template>

<script setup lang="ts">
import ProductAvailability from "vue-app/components/Products/ProductsList/ProductAvailability.vue";
import ProductReportDetailsImage from "./ProductReportDetailsImage.vue";
import ProductReportDetailsRow from "./ProductReportDetailsRow.vue";
import { formatPrice } from "vue-app/utils/functions";
import EdroneBadge from "edrone-components/EdroneBadge/EdroneBadge.vue";
import { PRODUCT_RECOMMENDATION_STATUS } from "vue-app/components/ProductReport/ProductReport.enum";
import ProductRecommendationStatusToggle from "vue-app/components/Products/ProductRecommendationStatusToggle.vue";

interface Props {
  productName: string | null;
  price: number | null;
  imageUrl: string | null;
  url: string | null;
  isLoading: boolean;
  isAvailable: boolean;
  isBestseller?: boolean;
  recommendationStatus: PRODUCT_RECOMMENDATION_STATUS;
  appIdProductId: string | null;
}

interface Emits {
  updateRecommendationStatus: [status: PRODUCT_RECOMMENDATION_STATUS];
}

defineProps<Props>();
defineEmits<Emits>();
</script>
